// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chatlist__item {
  border: 1px solid #ebe7fb;
  border-radius: 5px;
  margin-top: 10px;
  cursor: pointer;
  padding: 5px 10px;
  transition: all 0.3s cubic-bezier(0.88, 0.19, 0.37, 1.11);
  animation-name: showIn;
  animation-duration: 0.2s; /* or: Xms */
  animation-iteration-count: 1;
  animation-direction: normal; /* or: normal */
  animation-timing-function: cubic-bezier(0.88, 0.19, 0.37, 1.11); /* or: ease, ease-in, ease-in-out, linear, cubic-bezier(x1, y1, x2, y2) */
  animation-fill-mode: both; /* or: backwards, both, none */
  animation-delay: 0.1s; /* or: Xms */
}

@keyframes showIn {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Chat/ChatItem/chatitem.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yDAAA;EACA,sBAAA;EACA,wBAAA,EAAA,YAAA;EACA,4BAAA;EACA,2BAAA,EAAA,eAAA;EACA,+DAAA,EAKG,yEAAA;EACH,yBAAA,EAAA,8BAAA;EACA,qBAAA,EAAA,YAAA;AAJF;;AAOA;EACE;IACE,mBAAA;EAJF;EAMA;IACE,mBAAA;EAJF;AACF","sourcesContent":[".chatlist__item {\n  border: 1px solid #ebe7fb;\n  border-radius: 5px;\n  margin-top: 10px;\n  cursor: pointer;\n  padding: 5px 10px;\n  transition: all 0.3s cubic-bezier(0.88, 0.19, 0.37, 1.11);\n  animation-name: showIn;\n  animation-duration: 0.2s; /* or: Xms */\n  animation-iteration-count: 1;\n  animation-direction: normal; /* or: normal */\n  animation-timing-function: cubic-bezier(\n    0.88,\n    0.19,\n    0.37,\n    1.11\n  ); /* or: ease, ease-in, ease-in-out, linear, cubic-bezier(x1, y1, x2, y2) */\n  animation-fill-mode: both; /* or: backwards, both, none */\n  animation-delay: 0.1s; /* or: Xms */\n}\n\n@keyframes showIn {\n  0% {\n    transform: scale(0);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
